export default "__VITE_ASSET__4179d27b__"